import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import configureStore from "./configure-store";

import App from "./components";
import { AdvanceTheme } from "../../../shared/components/advance-theme/AdvanceTheme";

const GivingDayMenuBar = (props) => {
  const store = configureStore(props);

  return (
    <AdvanceTheme>
      <Provider store={store}>
        <BrowserRouter>
          <App {...props} />
        </BrowserRouter>
      </Provider>
    </AdvanceTheme>
  );
};

export default GivingDayMenuBar;
